import { Flex } from 'antd';
import React from 'react';
import styled from 'styled-components';

const AiMessageContainerWrapper = styled.div`
  font-size: 16px;
  line-height: 1.2;
`;

export interface IAiMessageContainerProps {
  children?: React.ReactNode;
  isBackoffice?: boolean;
}
/**
 * Wrapper per il testo di un messaggio di AI.
 */
export function AiMessageContainer(props: IAiMessageContainerProps) {
  const { children, isBackoffice } = props;

  return (
    <AiMessageContainerWrapper>
      {isBackoffice ? (
        <Flex vertical={isBackoffice}>{children}</Flex>
      ) : (
        children
      )}
    </AiMessageContainerWrapper>
  );
}
